import './index.scss'
function Chapter(){
    return (
        <div className='container'>ddd</div>
    )
}
export default Chapter;